var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIhand(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 91,
    viewBox: "0 0 81 91",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45.3888 78.0781C45.3888 78.0781 44.9391 70.1341 45.3888 64.8873C45.8385 59.6405 45.3888 55.294 44.3393 52.5959C43.2897 49.8979 41.9407 42.4036 44.3393 31.1618C46.7378 19.9199 46.7378 24.1172 48.2361 16.0231C49.7345 7.92893 50.4845 0.434671 53.482 1.03364C56.4796 1.6335 53.7815 7.62855 53.482 9.42725C53.1825 11.2259 53.3318 14.8233 52.7329 19.0206C52.1339 23.2178 53.7824 25.316 53.7824 25.316",
    stroke: "#F9BF2E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M61.1271 32.0609C60.7152 28.0884 60.752 24.491 60.752 24.491C60.752 19.9943 59.5154 19.9943 57.3795 20.1067C55.2435 20.2191 52.7568 22.6024 52.7568 22.6024",
    stroke: "#F9BF2E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M59.4141 20.274C59.4141 20.274 60.8278 17.2216 63.0007 17.3718C65.1744 17.522 66.9731 18.38 66.9731 20.274C66.9731 22.168 66.4488 24.3418 66.0737 27.9392C65.6987 31.5365 65.9991 37.7573 65.9991 37.7573C65.9991 37.7573 66.2986 40.8304 63.6005 40.6802C60.9025 40.53 60.603 38.4318 60.7523 36.5585C60.7523 36.5585 61.1273 34.4603 61.1273 32.0618",
    stroke: "#F9BF2E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M54.3071 27.1147C54.3071 27.1147 55.0563 31.0494 55.3935 32.2113C55.7308 33.3733 55.2811 39.9682 57.7921 40.2677C60.3031 40.5672 60.7339 40.1157 60.724 37.4563",
    stroke: "#F9BF2E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M65.938 36.1053C65.938 36.1053 65.8489 38.3564 68.1351 38.2817C70.4212 38.2071 71.2828 36.2204 71.5076 34.4217C71.7325 32.6231 72.1444 29.4376 72.4447 28.3889C72.6435 27.6946 73.104 25.4256 73.3927 23.9695C73.5402 23.2249 73.6436 22.6934 73.6436 22.6934C73.6436 22.6934 74.1679 19.8829 70.7953 18.9089C67.4228 17.9349 66.9632 20.7103 66.9632 20.7103",
    stroke: "#F9BF2E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M73.6721 22.3552C73.6721 22.3552 76.64 18.3081 78.177 18.3081C79.7131 18.3081 80.5 19.4701 79.2265 21.9055C77.9521 24.3409 78.5142 27.3394 78.5142 27.3394C78.5142 27.3394 78.6644 28.8008 78.2516 30.4124C77.8388 32.0241 77.2399 37.0451 77.2021 38.9562C77.1643 40.8673 77.2767 41.5796 75.6282 42.8531C73.9797 44.1275 70.5694 47.0872 69.3706 48.474C68.1717 49.8608 67.1968 50.985 65.3235 52.5957C63.4502 54.2074 64.0491 56.4926 64.0491 57.9541C64.0491 59.4155 64.7983 69.6078 64.8361 73.6926C64.8738 77.7775 65.8101 80.9998 65.8101 80.9998",
    stroke: "#F9BF2E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M51.0288 29.0259C51.0288 29.0259 52.6144 30.2337 54.8852 30.0044",
    stroke: "#F9BF2E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M72.9663 26.0696C72.9663 26.0696 73.0463 27.6587 73.6723 28.4915",
    stroke: "#F9BF2E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M27.9297 78H22.0703V49.5625H27.9297V78Z",
    fill: "url(#paint0_diamond)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_diamond",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(24.2424 66.8929) rotate(88.0754) scale(45.1147 45.0815)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD458",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F9BF2E"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIhand);
export default __webpack_public_path__ + "static/media/Ihand.43b95d3555d165bd3ee916bf963f1b62.svg";
export { ForwardRef as ReactComponent };